import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { IParams } from '@domain/interfaces/IParams';
import { EProgressBarStep } from '@domain/enums/onboarding/progressBar/ESteps';

import { useEcommerce } from '@helpers/hooks/pages/onboarding/useEcommerce';

import { ECOMMERCE_GATEWAYS } from '@constants/common/integrations';

import SideBar from '@components/Onboarding/SideBar';

import * as S from './styles';

const Gateways: React.FC = () => {
  const {
    selectedGateways,
    hasSelectedStoreIntegrations,
    currentGatewayToIntegrate,
    handleNextGatewayToIntegrate,
  } = useEcommerce();

  const { storeAliasId } = useParams<IParams>();
  const history = useHistory();

  const getGatewayContent = React.useCallback(
    (integration: typeof ECOMMERCE_GATEWAYS[number] | undefined) => {
      if (integration) {
        const Content = integration.onboardingContent;

        return <Content />;
      }

      return <></>;
    },
    [],
  );

  React.useEffect(() => {
    if (!selectedGateways.length && !currentGatewayToIntegrate && hasSelectedStoreIntegrations) {
      history.push(`/onboarding/${storeAliasId}/ecommerce/integrations/marketing`);
    }

    if (!selectedGateways.length && !currentGatewayToIntegrate && !hasSelectedStoreIntegrations) {
      history.push(`/onboarding/${storeAliasId}/ecommerce/integrations`);
    }

    if (!currentGatewayToIntegrate) {
      handleNextGatewayToIntegrate();
    }
  }, [
    selectedGateways,
    currentGatewayToIntegrate,
    history,
    storeAliasId,
    handleNextGatewayToIntegrate,
    hasSelectedStoreIntegrations,
  ]);

  const foundGateway = ECOMMERCE_GATEWAYS.find(
    integration => integration.identifier === currentGatewayToIntegrate,
  );

  return (
    <S.Container>
      <SideBar
        onboardingStep={EProgressBarStep.INTEGRATIONS}
        linkToGoBack={`/onboarding/${storeAliasId}/ecommerce/integrations`}
      />
      {getGatewayContent(foundGateway)}
    </S.Container>
  );
};

export default Gateways;
